import { useContext } from 'react'

import UserContext from 'auth/context/UserContext'

export function useUser() {
  return useContext(UserContext)
}

export default useUser
